import React, { forwardRef, useState } from 'react';
import { BottomSheetProps } from 'react-spring-bottom-sheet';
import { SpringEvent } from 'react-spring-bottom-sheet/dist/types';

import { useDisableBodyScrollOnTrigger } from '../../hooks/useDisableBodyScroll';
import { StyledBottomSheet } from './BottomSheet.styles';

export const BOTTOMSHEET_MAX_TOP_MARGIN = '3.5rem';

interface StyledBottomSheetProps extends BottomSheetProps {
  zIndex?: number;
}
const BottomSheet = forwardRef((props: StyledBottomSheetProps, ref: React.Ref<any>) => {
  const { zIndex, ...rest } = props;
  const [isOpen, setIsOpen] = useState(false);
  useDisableBodyScrollOnTrigger(isOpen);

  const handleSpringStart = (event: SpringEvent) => {
    const nextIsOpen = event.type === 'CLOSE' ? false : true;
    setIsOpen(nextIsOpen);
  };

  return (
    <StyledBottomSheet onSpringStart={handleSpringStart} zIndex={zIndex} {...rest} scrollLocking={false} ref={ref} />
  );
});
export default BottomSheet;
